import type Guid from "@/app/types/common/guid";
import { makeRef } from "@/components/composables/reactivityTypes";

const _salesCodeRestriction = makeRef<Guid | null>(null);

export const salesCodeRestriction = () => _salesCodeRestriction.value;
export const setSalesCodeRestriction = (newVal: Guid | null) => {
  _salesCodeRestriction.value = newVal;
};
